"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ykbTextMask = require("ykb-text-mask");
var _react = _interopRequireDefault(require("react"));
var _Iban = _interopRequireDefault(require("../Iban"));
var _createNumberMask = _interopRequireDefault(require("../CurrencyInput/createNumberMask"));
var _moment = _interopRequireDefault(require("moment"));
var _ykbUtils = require("ykb-utils");
var _TemplateOption = _interopRequireDefault(require("../Select/TemplateOption"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _viewMode = _interopRequireDefault(require("../TextInput/viewMode"));
var selectView = function selectView(props, formValue) {
  var viewValue = '-';
  if (!(0, _ykbUtils.isNullOrUndefined)(formValue)) {
    if (props.data) {
      if (props.labelInValue) {
        if (Array.isArray(formValue)) {
          return formValue.map(function (item) {
            return item[props.labelKey];
          }).join(', ');
        } else {
          return formValue[props.labelKey] || viewValue;
        }
      } else if ((0, _typeof2.default)(formValue) !== 'object') {
        if (props.template && Object.keys(props.template).length > 0) {
          var option = {};
          if (Array.isArray(props.data) && props.data.length > 0) {
            option = props.data.find(function (q) {
              return q[props.valueKey] == formValue;
            });
          }
          viewValue = /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
            return /*#__PURE__*/_react.default.createElement(_TemplateOption.default, (0, _extends2.default)({
              theme: theme
            }, props, {
              option: option,
              viewMode: true
            }));
          });
        } else {
          Object.keys(props.data).forEach(function (i) {
            if (props.data[i].value === formValue) viewValue = props.data[i][props.labelKey];
          });
        }
      } else {
        // Multiselect
        var labelArray = [];
        formValue.forEach(function (val) {
          Object.keys(props.data).forEach(function (i) {
            if (props.valueKey) {
              if (props.data[i][props.valueKey] === val) {
                labelArray.push(props.data[i][props.labelKey]);
              } else if (props.data[i] === val) {
                // if the array is given as data
                labelArray.push(props.data[i]);
              }
            } else if (props.data[i].value === val) {
              labelArray.push(props.data[i][props.labelKey]);
            } else if (props.data[i] === val) {
              // if the array is given as data
              labelArray.push(props.data[i]);
            }
          });
        });
        return labelArray.join(', ');
      }
    } else if (Array.isArray(props.children)) {
      var _option = [];
      props.children.find(function (q) {
        if (Array.isArray(q)) {
          var childOption = q.find(function (w) {
            return w !== null && w !== void 0 && w.props ? Array.isArray(formValue) ? formValue.includes(w.props[props.valueKey]) : w.props[props.valueKey] == formValue : false;
          });
          if (childOption) {
            _option = childOption;
          }
        } else {
          if (q && q.props) {
            var propsValue = q.props[props.valueKey];
            if (Array.isArray(formValue)) {
              formValue.includes(propsValue) && _option.push(propsValue);
            } else {
              propsValue == formValue && (_option = q);
            }
          }
        }
      });
      return _option && Array.isArray(_option) ? _option.join(', ') : _option.props && _option.props.children;
    } else {
      return formValue;
    }
  }
  return viewValue;
};

//TODO: temizlik yap
var checkboxGroupView = function checkboxGroupView(props, formValue) {
  var viewValue = [];
  if (props.items) {
    formValue.map(function (item) {
      props.items.filter(function (propItem) {
        if (propItem.value === item) {
          viewValue.push(propItem.textLabel);
        }
      });
    });
  }
  if (viewValue.length > 0) {
    return viewValue.join(', ');
  } else {
    return '-';
  }
};
var _findJSNodeByValue = function findJSNodeByValue(node, key) {
  // Exit Condition ---
  if (node.value == key) {
    return node;
  }
  // ------
  if (!Array.isArray(node.children) || node.children.length === 0) return null;
  var result = null;
  node.children.map(function (el) {
    result = result ? result : _findJSNodeByValue(el, key);
  });
  return result;
};
var _findReactNodeByValue = function findReactNodeByValue(node, key) {
  if (!node) return null;
  // Exit Condition ---
  if (node.props.value == key) {
    return node;
  }
  // ------
  var arr = Array.isArray(node.props.children) ? node.props.children : [node.props.children];
  if (arr.length === 0) return null;
  var result = null;
  arr.map(function (el) {
    result = result ? result : _findReactNodeByValue(el, key);
  });
  return result;
};
var treeSelectView = function treeSelectView(props, formValue) {
  var viewValue = '-';
  if (Array.isArray(formValue) && formValue.length > 0) {
    var labelArray = [];
    if (props.treeData) {
      // Converts to Tree Structure,
      // In this traversal method we can access child from parent directly (ie: parentNode.children => childNodes)
      var tree = {
        children: props.treeData
      };
      formValue.forEach(function (val) {
        var res = _findJSNodeByValue(tree, val);
        if (res) {
          labelArray.push(res.title);
        }
      });
    } else if (props.children) {
      // Converts to Tree Structure,
      // In this traversal method, we cant access it directly (ie: parentNode.props.children => childNodes)
      var _tree = {
        props: {
          children: props.children
        }
      };
      formValue.forEach(function (val) {
        var res = _findReactNodeByValue(_tree, val);
        if (res) {
          labelArray.push(res.props.title);
        }
      });
    }
    return labelArray.join(', ');
  }
  return viewValue;
};
var radioGroupView = function radioGroupView(props, formValue) {
  var result;
  if (props.items) {
    result = props.items.filter(function (item) {
      if (item.value === formValue) {
        return item.textLabel;
      }
    });
  }
  if (result && result.length === 1) {
    return result[0].textLabel;
  } else {
    return '-';
  }
};
var phoneInputView = function phoneInputView(props, formValue) {
  var parsedValue = typeof formValue === 'string' ? formValue : String(formValue);
  if (!parsedValue || parsedValue && parsedValue.length !== 10) return '-';
  var result = (0, _ykbTextMask.conformToMask)(parsedValue, props.mask);
  return result.conformedValue;
};
var currencyInputView = function currencyInputView(props, formValue, defaultProps) {
  if ((0, _ykbUtils.isNullOrUndefined)(formValue) || formValue === '') return '-';
  // const mask = props.mask(String(formValue));
  // debugger;
  // const result = conformToMask(String(formValue), mask);
  // return result.conformedValue;

  var currencyMask = (0, _createNumberMask.default)({
    prefix: '',
    decimalSymbol: props.decimalSymbol ? props.decimalSymbol : defaultProps.decimalSymbol,
    thousandsSeparatorSymbol: props.thousandsSeparatorSymbol ? props.thousandsSeparatorSymbol : defaultProps.thousandsSeparatorSymbol,
    includeThousandsSeparator: defaultProps.includeThousandsSeparator,
    allowDecimal: defaultProps.allowDecimal,
    allowLeadingZeroes: defaultProps.allowLeadingZeroes,
    decimalLimit: props.decimalLimit || defaultProps.decimalLimit
  });
  var result = (0, _ykbTextMask.conformToMask)(String(formValue).replace('.', props.decimalSymbol ? props.decimalSymbol : defaultProps.decimalSymbol), currencyMask);
  result = result.conformedValue;
  if (props.currencyType || props.currencyType == '') {
    return "".concat(result, " ").concat(props.currencyType);
  } else if (props.currencyType !== false && defaultProps.currencyType) {
    return "".concat(result, " ").concat(defaultProps.currencyType);
  }
};
var datePickerView = function datePickerView(props, formValue) {
  if (!formValue || formValue === '') return '-';
  var momentValue = formValue;
  if (!_moment.default.isMoment(formValue)) {
    momentValue = (0, _moment.default)(formValue, props.format);
    // print the value anyway
    if (!momentValue.isValid()) {
      return formValue;
    }
  }
  var dateFormat = 'DD/MM/YYYY';
  var dateTimeFormat = 'DD/MM/YYYY HH:mm:ss';
  var showTime = props.showTime;
  var date = showTime ? momentValue.format(dateTimeFormat) : momentValue.format(dateFormat);
  return date;
};
var monthPickerView = function monthPickerView(props, formValue) {
  if (!formValue || formValue === '' || !formValue.isValid()) return '-';
  return formValue.format('YYYY-MM');
};
var weekPickerView = function weekPickerView(props, formValue) {
  if (!formValue || formValue === '' || !formValue.isValid()) return '-';
  return formValue.format('gggg-ww');
};
var yearPickerView = function yearPickerView(props, formValue) {
  if (!formValue || formValue === '' || !formValue.isValid()) return '-';
  return formValue.year();
};
var timePickerView = function timePickerView(props, formValue) {
  if (!formValue || formValue === '' || !formValue.isValid()) return '-';
  var format = props.format || 'HH:mm:ss';
  return formValue.format(format);
};
var rangePickerView = function rangePickerView(props, formValue) {
  if (!formValue || formValue === '') return '-';
  var start = formValue[0];
  var end = formValue[1];
  var format = props.format || 'DD-MM-YYYY';
  if (props.picker && (0, _ykbUtils.isNullOrUndefined)(props.format)) {
    if (props.picker == 'month') {
      format = 'YYYY-MM';
    } else if (props.picker == 'week') {
      format = 'gggg-ww';
    } else if (props.picker == 'year') {
      format = 'YYYY';
    } else if (props.picker == 'time') {
      format = 'HH:mm:ss';
    }
  }
  var startDate = _moment.default.isMoment(start) ? start.format(format) : '';
  var endDate = _moment.default.isMoment(end) ? end.format(format) : '';
  return [startDate, endDate].join(' ~ ');
};
var checkboxView = function checkboxView(props, formValue) {
  return "".concat(formValue);
};
var ibanView = function ibanView(props, formValue) {
  return /*#__PURE__*/_react.default.createElement(_Iban.default, {
    value: formValue
  });
};
var switchView = function switchView(props, formValue) {
  return "".concat(formValue);
};
var textInputView = function textInputView(props, formValue) {
  return /*#__PURE__*/_react.default.createElement(_viewMode.default, (0, _extends2.default)({}, props, {
    viewValue: formValue
  }));
};
var _default = exports.default = {
  Select: selectView,
  CheckboxGroup: checkboxGroupView,
  RadioGroup: radioGroupView,
  PhoneInput: phoneInputView,
  CurrencyInput: currencyInputView,
  Datepicker: datePickerView,
  Checkbox: checkboxView,
  IbanInput: ibanView,
  MonthPicker: monthPickerView,
  WeekPicker: weekPickerView,
  YearPicker: yearPickerView,
  TimePicker: timePickerView,
  RangePicker: rangePickerView,
  TreeSelect: treeSelectView,
  Switch: switchView,
  TextInput: textInputView
};